import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SharedService } from '../../../../../Services/shared.service';
import { API_End_Point } from '../../../../../Services/API_End_Point';
import { SumPipe } from '../../../../../Services/pipes/sum.pipe';
import { Chart, ChartConfiguration, registerables } from 'chart.js';
Chart.register(...registerables); // registers BarController, BarElement, CategoryScale, etc.

@Component({
  selector: 'app-view-progress-report',
  standalone: true,
  imports: [RouterModule, CommonModule, SumPipe],
  templateUrl: './view-progress-report.component.html',
  styleUrl: './view-progress-report.component.css'
})
export class ViewProgressReportComponent {
  ReportData: any = null;
  constructor(public _svc: SharedService,
    private _activatedRoute: ActivatedRoute
  ) {

  }
  ngOnInit(): void {
    this._activatedRoute.queryParamMap.subscribe(params => {

      this.ViewReport(Number(params.get('id') ?? '0'));
    });
  }
  ViewReport(PowerPrepStatusId: number): void {

    this._svc.GET(API_End_Point.ViewReport(PowerPrepStatusId))
      .subscribe((res) => {
        if (res.result === 'success') {
          this.ReportData = res.data;
          setTimeout(() => {
            this.render_UnitChart();
            this.render_ChapterChart();
          }, 100)

        } else {
          this.ReportData = null;
        }
      });
  }

  render_UnitChart() {
    const ctx = document.getElementById('unitChart') as HTMLCanvasElement;

    const data = {
      labels: this.ReportData.unitSummary.map((item: any) => item.UnitNo),
      datasets: [
        {
          label: 'Obtained Marks',
          data: this.ReportData.unitSummary.map((item: any) => item.ObtainedMarks),
          backgroundColor: 'rgba(54, 162, 235, 0.6)',
          barPercentage: 0.4,
          categoryPercentage: 0.6,
        }
      ],
      options: {
        responsive: true,
        plugins: {
          legend: { position: 'top' },
        }
      }
    };

    new Chart(ctx, {
      type: 'bar',  // Change to 'pie', 'line', etc.
      data: data,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Performance by Unit'
          }
        }
      },
    } as ChartConfiguration);
  }
  render_ChapterChart() {
    const ctx = document.getElementById('chpterChart') as HTMLCanvasElement;
    
    ctx.height = this.ReportData.chapterSummary.length * 40;
    const data = {
      labels: this.ReportData.chapterSummary.map((item: any) => item.ChapterName),
      datasets: [
        {
          label: 'Obtained Marks',
          // data: this.ReportData.chapterSummary.map((item: any) => (item.ObtainedMarks / item.ObtainedMarks) * 100),
          data: this.ReportData.chapterSummary.map((item: any) => (item.ObtainedMarks )),
          backgroundColor: 'rgba(54, 162, 235, 0.6)',
          barPercentage: 0.4,
          categoryPercentage: 0.6,
        }
      ],
      options: {
        responsive: true,

        plugins: {
          legend: { position: 'top' },
        }
      }
    };

    new Chart(ctx, {
      type: 'bar',
      data: data,
      options: {
        indexAxis: 'y',
        responsive: true,

        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Performance by Chapter'
          }
        }
      },
    } as ChartConfiguration);
  }

  print() {

    const printContent = document.getElementById("content");
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0,-webkit-print-color-adjust: exact; ');
    WindowPrt!.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }

            table, td, th {
              border: 1px solid #ccc;
              border-collapse: collapse;
            }

            tr:nth-child(even) {
              background-color: #f9f9f9;
            }

            tr:nth-child(odd) {
              background-color: #ffffff;
            }

            td, th {
              padding: 8px;
            }
              @media print {
  table {
    width: 100%;
    border-collapse: collapse;
    page-break-inside: auto;
  }

  thead {
    display: table-header-group;
  }

  tfoot {
    display: table-footer-group;
  }

  tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
          </style>
        </head>
        <body>
          ${printContent!.innerHTML}
        </body>
      </html>
    `);

    WindowPrt!.document.close();
    WindowPrt!.focus();
    WindowPrt!.print();

    // WindowPrt!.close();
  }

  formatTimeFromSeconds(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const minText = minutes > 0 ? `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}` : '';
  const secText = seconds > 0 ? `${seconds} ${seconds === 1 ? 'second' : 'seconds'}` : '';

  if (minText && secText) {
    return `${minText} and ${secText}`;
  }
  return minText || secText || '0 seconds';
}
}
